<template>
  <div>
    <vue-advanced-chat
        ref="chatWindow"
        :height="isAndroid ? 'calc(100vh)' : 'calc(100vh - 55px)'"
        :current-user-id="myUser"
        :room-id="roomId"
        :single-room="'true'"
        :rooms="JSON.stringify(loadedRooms)"
        :loading-rooms="JSON.stringify(loadingRooms)"
        :rooms-loaded="JSON.stringify(roomsLoaded)"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messagesLoaded"
        :menu-actions="JSON.stringify(menuActionForRoom)"
        :message-selection-actions="JSON.stringify(messageSelectionActions)"
        :text-messages="JSON.stringify(textMessages)"
        :show-audio="'false'"
        :media-preview-enabled="'false'"
        :message-actions="JSON.stringify(messageActions)"
        :show-reaction-emojis="'false'"
        :show-emojis="'false'"
        :show-new-messages-divider="'false'"
        :textarea-auto-focus="'false'"
        :styles="JSON.stringify(styles)"
        :username-options="JSON.stringify({minUsers: 2, currentUser: false})"
        :textarea-action-enabled="'true'"
        @fetch-messages="fetchMessages($event.detail[0])"
        @send-message="sendMessage($event.detail[0])"
        @menu-action-handler="handleRoomAction($event.detail[0])"
        @open-file="onOpenFile($event.detail[0])"
        @message-selection-action-handler="messageSelected($event.detail[0])"
        @message-action-handler="messageAction($event.detail[0])"
    >
      <div slot="spinner-icon-infinite-rooms">
        <div id="vac-circle" v-if="loadingRooms"></div>
      </div>
      <div slot="custom-action-icon" style="display: flex; justify-items: center; margin-left: 8px">
        <mic-icon title="" v-tooltip="'Nachricht aufnehmen'" @click="openMic" class="icon-1_5x" fillColor="#2463ea"
        style="cursor: pointer; color: #2463ea;" :size="72" ></mic-icon>
      </div>
      <!--div v-for="(message, index) in messages" :slot="'message-avatar_' + message._id"
           :class="[message.senderId !== myUser ? 'chat-avatar' : 'chat-avatar mine']" class="chat-avatar" v-if="index === 0 || messages[index-1].senderId !== message.senderId">
        {{getFistCharacter(message.username)}}
      </div-->
    </vue-advanced-chat>
    <b-modal size="sm" v-model="showGroup" centered title="Gruppenmitglieder"
    >
      <b-row class="mt-2">
        <b-col>
          <div v-for="item in roomUsers" :key="item" style="padding: 4px;">
            {{ item }}
          </div>
        </b-col>
      </b-row>
      <template #modal-footer="{ok}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showGroup = false">
          Ok
        </b-button>
      </template>
    </b-modal>
    <media-preview v-if="showPreview" @close-media-preview="hidePreview" :file="previewFile"></media-preview>
    <b-modal size="md" v-model="showInviteUser" centered title="Nutzer hinzufügen"
    >
      <b-row class="mt-2">
        <b-col>
          <span>Mitarbeiter auswählen</span>
          <v-jstree ref="js_tree_2" :allow-transition="false"
                    style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; margin-top: 0.75rem"
                    class="my-tree" :data="possibleInvites"
                    @item-click="onInviteItemClicked"
                    show-checkbox
                    :multiple="false"
                    :allow-batch="false"></v-jstree>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showInviteUser = false">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="selectedInvite === null" variant="success" @click="onInvite">
          Hinzufügen
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>

import {register} from 'vue-advanced-chat'
import {isImageFile, Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import VJstree from "vue-jstree";
import MediaPreview from "../messaging/util/MediaPreview.vue"
import {
  decryptAES,
  decryptChatMessages,
  decryptFile,
  decryptRooms,
  encryptAES,
  encryptEntry,
  encryptFile
} from "@/shared/crypto";
import {formatTimestamp, parseTimestamp} from "@/shared/dates";
import {v4, v4 as uuidv4} from 'uuid';
import MicIcon from 'vue-material-design-icons/MicrophoneOutline.vue'

const messageRefreshRate = 1000;
register()
export default {
  name: "messaging",
  components: {
    VJstree,
    MediaPreview,
    MicIcon
  },
  data() {
    return {
      isAndroid: false,
      // util
      loader: undefined,
      // file preview
      previewFile: null,
      showPreview: false,
      // show room users
      showGroup: false,
      roomUsers: [],
      // create room
      showCreateRoom: false,
      possibleUser: [],
      selectedUser: [],
      selectedUserNames: [],
      roomName: "",
      currentNewId: '',
      // chat config
      myUser: "",
      roomsPerPage: 20,
      rooms: [],
      roomId: '',
      roomsLoaded: false,
      loadingRooms: true,
      roomsLoadedCount: 0,
      selectedRoom: null,
      messagesPerPage: 20,
      messages: [],
      messagesLoaded: false,
      menuActions: [
        {name: 'showUsers', title: 'Gruppenmitglieder anzeigen'},
        {name: 'inviteUser', title: 'Nutzer hinzufügen'}
      ],
      messageSelectionActions: [{name: 'newTask', title: 'Neue Aufgabe anlegen'}],
      messageActions: [
        {
          name: 'selectMessages',
          title: 'Markieren'
        },
        {
          name: 'newTaskFromMessage',
          title: 'Neue Aufgabe anlegen'
        }
      ],
      styles: {
        message: {
          background: '#fff',
          backgroundMe: '#e8eff8',
        }
      },
      textMessages: {
        ROOMS_EMPTY: 'Sie haben noch keine Chats.',
        ROOM_EMPTY: 'Kein Chat geöffnet',
        NEW_MESSAGES: 'Neue Nachrichten',
        MESSAGE_DELETED: 'Nachricht geloescht',
        MESSAGES_EMPTY: 'Keine Nachrichten im Chat',
        SEARCH: 'Suchen',
        CANCEL_SELECT_MESSAGE: 'Selektion beenden',
        TYPE_MESSAGE: 'Nachricht schreiben',
        CONVERSATION_STARTED: 'Beginn der Konversation: ',
      },
      // timers
      refreshRoomsTimer: null,
      refreshMessagesTimer: null,
      // invite users
      showInviteUser: false,
      possibleInvites: [],
      selectedInvite: null,
    }
  },
  beforeMount(){
    window['AndroidWebView'] = {
      components:  this,
      onSetDescription: (msg) =>  this.onSetDescription(msg),
      onPause: () => this.onPause(),
      onUnpause: () => this.onUnpause(),
    };
  },
  beforeDestroy() {
    clearInterval(this.refreshMessagesTimer);
    this.refreshMessagesTimer = null;
  },
  computed: {
    menuActionForRoom() {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === this.selectedRoom) {
          let r = this.rooms[i];
          let res = [];
          res.push(this.menuActions[0]);
          if (r.room_type === "task") {
            res.push(this.menuActions[1])
          }
          if (r.room_type !== "chat") {
            res.push(this.menuActions[2]);
          }
          return res;
          break;
        }
      }
      return [];
    },
    loadedRooms() {
      return this.rooms.slice(0, this.roomsLoadedCount)
    },
    oldestMessage() {
      let oldest = Number.MAX_SAFE_INTEGER;
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i]._id !== '0' && this.messages[i].indexId < oldest) {
          oldest = this.messages[i].indexId;
        }
      }
      return oldest;
    },
    latestMessage() {
      let latest = 0;
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].indexId > latest) {
          latest = this.messages[i].indexId;
        }
      }
      return latest;
    }
  },
  mounted() {
    //this.fetchRooms()
    //console.log(this.$refs.chatWindow.shadowRoot.)
    this.isAndroid = navigator.userAgent === "BisOfficeMobile";
    var sheet = new CSSStyleSheet();
    sheet.replaceSync( `.vac-message-wrapper .vac-message-container {
  width: 95% !important;
}


.vac-message-wrapper .vac-message-box{
  width: 100% !important;
  min-width: 100% !important;
}
.vac-message-files-container .vac-file-wrapper .vac-file-container {
    width: auto !important;
    max-width: 150px !important;
  }
  .vac-message-files-container .vac-file-wrapper {
     margin: 0 auto;
  }

.vac-message-wrapper .vac-offset-current {
  margin-left: 0px !important;
}`)
    this.$refs.chatWindow.shadowRoot.adoptedStyleSheets = [ sheet ]
    this.currentUserId = this.$cookies.get("ps_user_id");
    this.myUser = this.currentUserId;
    if (this.$route.query.back_step && this.$route.query.back_step === "true") {

    }
    this.showLoader();
    this.$http.get(
        Server_URL + '/auftragsbuch/messaging/rooms/' + this.$route.params.id+"?task="+this.$route.query.is_task
    ).then(this.handleDataOk, this.responseError)
  },
  methods: {
    onPause() {
      clearInterval(this.refreshMessagesTimer);
      this.refreshMessagesTimer = null;
    },
    onUnpause() {
      if (!this.refreshMessagesTimer) {
        this.refreshMessagesTimer = setInterval(() => {
          this.fetchMoreMessages(true)
        }, messageRefreshRate)
      }
    },
    openMic() {
      Android.openMic();
    },
    onSetDescription(desc) {
      let el = this.$refs.chatWindow.shadowRoot.getElementById('roomTextarea');
      el.value = desc;
      let evt = new Event("input", {"bubbles":true, "cancelable":false});
      el.dispatchEvent(evt);
    },
    handleDataOk(response) {
      if (response.status === 200) {
        let data = response.body;
        this.possibleUser = this.setNames(data.possible_users);
        let rooms = [data.room]
        this.hideLoader();
        decryptRooms(sessionStorage.getItem("aes"), rooms).then(res => {
          this.processRooms(res)
        })
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async onInvite() {
      this.showInviteUser = false;
      clearInterval(this.refreshMessagesTimer);
      this.refreshMessagesTimer = null;
      let room = null;
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === this.selectedRoom) {
          room = this.rooms[i]
          break
        }
      }
      if (!room) {
        if (!this.refreshMessagesTimer) {
          this.refreshMessagesTimer = setInterval(() => {
            this.fetchMoreMessages(true)
          }, messageRefreshRate)
        }
        return
      }
      let me = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let them = JSON.parse(sessionStorage.getItem(this.selectedInvite.id));
      let messagePlain = me.full_name + " hat " + them.full_name + " hinzugefügt."
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), messagePlain);

      let req = {
        user_name: me.full_name,
        room_id: parseInt(this.selectedRoom),
        latest_message_id: this.latestMessage,
        data_id: room.uniqueness,
        user_id: this.selectedInvite.id,
        invite_message: encryptedContent,
        invite_message_plain: messagePlain,
      }
      let response;
      try {
        response = await this.$http.post(
            Server_URL + '/auftragsbuch/messaging/room/invite', req
        )
      } catch (e) {
        this.responseError(e)
        return
      }
      if (response.status !== 200) {
        window.location = Redirect_500;
        return
      }
      let newMessages = response.body.messages;
      for (let i = 0; i < newMessages.length; i++) {
        if (newMessages[i].value_3 === "system") {
          newMessages[i].system = true;
        }
        if (newMessages[i].message_type === 'file' && newMessages[i].files) {
          for (let j = 0; j < newMessages[i].files.length; j++) {
            newMessages[i].files[j].server_url = Server_URL + "/auftragsbuch/" + newMessages[i].files[j].url;
            newMessages[i].files[j].url = this.getThumbnailUrl(Server_URL + "/auftragsbuch/" + newMessages[i].files[j].url, newMessages[i].files[j].id, newMessages[i].files[j].type)
          }
        }
        let msg = this.formatMessage(newMessages[i]);
        msg.content = await decryptAES(sessionStorage.getItem("aes"), msg.content)
        this.messages.push(msg)
      }
      if (!this.refreshMessagesTimer) {
        this.refreshMessagesTimer = setInterval(() => {
          this.fetchMoreMessages(true)
        }, messageRefreshRate)
      }
      // update the room to reflect the new user
      for (let i = 0; i < this.rooms.length; i++) {
        let cur = this.rooms[i];
        if (cur.roomId === this.selectedRoom) {
          this.rooms[i].users.push({
            _id: this.selectedInvite.id,
            username: them.full_name,
          });
          this.rooms = [...this.rooms]
          break;
        }
      }
    },
    onInviteItemClicked(node, item, e) {
      this.selectedInvite = item;
    },
    getFistCharacter(name) {
      return name.charAt(0).toUpperCase()
    },
    messageSelected({ roomId, action, messages }) {
      let messageIds = [];
      for (let i = 0; i < messages.length; i++) {
        messageIds.push(messages[i]._id);
      }
      this.createTaskFromMessages(roomId, messageIds);
    },
    messageAction({ roomId, action, message }) {
      this.createTaskFromMessages(roomId, [message._id])
    },
    createTaskFromMessages(roomId, messageIds) {
      let dataId = uuidv4();
      Android.onCreateTask(dataId, JSON.stringify({
        roomId: roomId,
        messages: messageIds
      }));
      //this.$router.push("/create?message_payload=" + dataId);
    },
    hidePreview() {
      this.showPreview = false;
      URL.revokeObjectURL(this.previewFile.url);
    },
    async onOpenFile({ message, file }) {
      if (navigator.userAgent === "BisOfficeMobile") {
        Android.onLoadFile(file.file.server_url);
        return
      }
      this.showLoader();
      // get the file blob
      try {
        let response = await this.$http.get(
            file.file.server_url, {responseType: 'blob'}
        )
        let blobData = await response.blob();
        let dec = await decryptFile(sessionStorage.getItem("aes"), await blobData.arrayBuffer());
        this.hideLoader();
        const b =  new File([dec], file.file.name, {type: blobData.type});
        const blobUrl = URL.createObjectURL(b);
        if (file.action === "preview") {
          this.previewFile = {url: blobUrl}
          this.showPreview = true;
        } else {
          window.open(blobUrl, file.file.name);
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 1000);
        }

      } catch (error) {
        console.log(error)
        //this.responseError(error)
      }
    },
    async handleRoomAction({ roomId, action }) {
      if (action.name === "showUsers") {
        this.showRoomUsers({ roomId, action });
      } else if (action.name === "gotoTask") {
        let room = null;
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].roomId === roomId) {
            room = this.rooms[i];
            break
          }
        }
        if (!room) {
          return
        }
        this.$router.push("/auftraege/auftrag/" + room.uniqueness);
      } else if(action.name === "inviteUser") {
        let room = null;
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].roomId === roomId) {
            room = this.rooms[i];
            break
          }
        }
        if (!room) {
          return
        }
        let selection = [];
        if (room.room_type === "task") {
          // todo query possible users
          let response;
          this.showLoader();
          try {
            response = await this.$http.get(
                Server_URL + '/auftragsbuch/messaging/room/invites/'+room.uniqueness
            )
          } catch (e) {
            this.hideLoader();
            this.responseError(e)
            return
          }
          this.hideLoader();
          let data = response.body;
          for (let i = 0; i < data.length; i++) {
            let cur = data[i];
            let found = this.isInRoom(room, cur);
            if (!found) {
              let res = JSON.parse(sessionStorage.getItem(cur));
              selection.push({
                id: cur,
                text: res.full_name,
                node_type: "user",
                icon: "icon-none",
                disabled: false,
                selected: false,
              })
            }
          }
          selection.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
        } else {
          selection = this.getCurrentPossibleSelection(this.possibleUser, room)
        }
        this.selectedInvite = null;
        this.possibleInvites = selection;
        this.showInviteUser = true;
      }
    },
    isInRoom(room, userId) {
      let found = false;
      for (let j = 0; j < room.users.length; j++) {
        if (userId === room.users[j]._id || userId === this.myUser) {
          found = true;
          break
        }
      }
      return found;
    },
    getCurrentPossibleSelection(org, room) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = {...org[i]};
        cur.selected = false;
        if (cur.node_type === 'user' && !this.isInRoom(room, cur.id)) {
          res.push(cur)
        } else if(cur.children !== null) {
          cur.children = this.getCurrentPossibleSelection(cur.children, room)
          res.push(cur)
        }
      }
      return res;
    },
    showRoomUsers({ roomId, action }) {
      this.roomUsers = [];
      // get the room =>
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === roomId) {
          let r = this.rooms[i];
          for (let j = 0; j < r.users.length; j++) {
            let res = JSON.parse(sessionStorage.getItem(r.users[j]._id))
            this.roomUsers.push(res.full_name);
          }
          break;
        }
      }
      //sort the room users
      this.roomUsers.sort((a, b) => {
        const nameA = a.toUpperCase(); // ignore upper and lowercase
        const nameB = b.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      this.showGroup = true;
    },
    async sendMessage({content, roomId, files, replyMessage}) {
      clearInterval(this.refreshMessagesTimer);
      this.refreshMessagesTimer = null;
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), content);
      // first insert the message
      let res = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let req = {
        room_id: parseInt(roomId),
        content: encryptedContent,
        content_plain: content,
        user_name: res.full_name,
        latest_message_id: this.latestMessage,
        has_file: files !== null,
      }
      let response;
      try {
        response = await this.$http.post(
            Server_URL + '/auftragsbuch/messaging/message', req
        )
      } catch (e) {
        this.responseError(e)
        return
      }
      if (response.status !== 200) {
        window.location = Redirect_500;
        return
      }
      let newMessages = response.body.messages;
      let newMessageId = response.body.message_id.toString();
      let newMessage = null;
      for (let i = 0; i < newMessages.length; i++) {
        let msg = this.formatMessage(newMessages[i]);
        msg.content = await decryptAES(sessionStorage.getItem("aes"), msg.content)
        if (newMessages[i]._id === newMessageId && files !== null) {
          newMessage = msg;
          for (let j = 0; j < files.length; j++) {
            files[j].uuid = uuidv4();
            let f = files[j];
            msg.files.push(
                {
                  name: f.name + (f.extension === "" ? "" : "." + f.extension),
                  size: f.size,
                  type: f.type,
                  audio: false,
                  duration: 0.0,
                  url: f.localUrl,
                  progress: 0,
                  uuid: f.uuid,
                }
            )
          }
        } else {
          if (newMessages[i].value_3 === "system") {
            newMessages[i].system = true;
          }
          if (newMessages[i].message_type === 'file' && newMessages[i].files) {
            for (let j = 0; j < newMessages[i].files.length; j++) {
              newMessages[i].files[j].server_url = Server_URL + "/auftragsbuch/" + newMessages[i].files[j].url;
              newMessages[i].files[j].url = this.getThumbnailUrl(Server_URL + "/auftragsbuch/" + newMessages[i].files[j].url, newMessages[i].files[j].id, newMessages[i].files[j].type)
            }
          }
        }
        this.messages.push(msg)
      }

      // insert new messages
      // build the message
      if (!this.refreshMessagesTimer) {
        this.refreshMessagesTimer = setInterval(() => {
          this.fetchMoreMessages(true)
        }, messageRefreshRate)
      }
      if (files !== null) {
        for (let i = 0; i < files.length; i++) {
          let data = new FormData();
          let f = files[i];
          data.set("room_id", roomId);
          data.set("message_id", newMessageId)
          data.set("file_id", f.uuid)
          try {
            if (!isImageFile({type: f.type})) {
              let enc = await encryptFile(sessionStorage.getItem("aes"), await f.blob.arrayBuffer())
              data.set("upload_file", new Blob([enc], {type: f.type}), f.name + (f.extension === "" ? "" : "." + f.extension))
            } else {
              data.set("upload_file", f.blob, f.name + (f.extension === "" ? "" : "." + f.extension))
              data.set("enc_key", sessionStorage.getItem("aes"))
            }
            try {
              response = await this.$http.post(
                  Server_URL + '/auftragsbuch/messaging/message_file', data, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    progress: (e) => {
                      if (e.lengthComputable) {
                        let progress = (e.loaded / e.total * 100);
                        for (let j = 0; j < newMessage.files.length; j++) {
                          if (newMessage.files[j].uuid === f.uuid) {
                            newMessage.files[j].progress = Math.round(progress);
                            this.messages = [...this.messages]
                            break;
                          }
                        }
                      }
                    }
                  }
              )
              if (response.status !== 200) {
                window.location = Redirect_500;
                return
              }
              f = response.body;
              for (let j = 0; j < newMessage.files.length; j++) {
                if (newMessage.files[j].uuid === f.id) {
                  delete newMessage.files[j].progress;
                  let thumbUrl = this.getThumbnailUrl(Server_URL + "/auftragsbuch/" + f.url, f.id, newMessage.files[j].type)
                  newMessage.files[j].url = thumbUrl;
                  newMessage.files[j].server_url = Server_URL + "/auftragsbuch/" + f.url;
                  this.messages = [...this.messages]
                  break
                }
              }
            } catch (r) {
              this.responseError(r)
            }
          } catch (e) {
            console.log(e)
          }
        }
      }
    },
    getThumbnailUrl(url, id, fileType) {
      if (!isImageFile({type: fileType})) {
        return ""
      } else {
        let splits = url.split("/")
        splits[splits.length - 1] = id + "_thumb.jpg"
        let res = splits.join("/");
        return res
      }
    },
    onItemClicked(node, item, e) {
      this.selectedUser = this.getSelectedUsers(this.possibleUser);
      this.selectedUserNames = this.getSelectedNames(this.possibleUser);
    },
    handleDataInit(response) {
      if (response.status === 200) {
        let data = response.body;
        this.possibleUser = this.setNames(data.possible_users);
        this.myUser = data.user_id;
        this.hideLoader();
        this.fetchRooms();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    setNames(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user') {
          let res = JSON.parse(sessionStorage.getItem(cur.id));
          if (res !== null) {
            org[i].text = res.first_name + " " + res.surname;
          }
        }
        if (cur.children !== null && cur.children.length > 0) {
          org[i].children = this.setNames(cur.children);
        }
      }
      return org
    },
    getSelectedUsers(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.id)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedUsers(cur.children))
        }
      }
      return res;
    },
    getSelectedNames(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.text)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedNames(cur.children))
        }
      }
      return res;
    },
    unselectUsers(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          org[i].selected = false;
        }
        if (cur.children !== null && cur.children.length > 0) {
          this.unselectUsers(cur.children)
        }
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    processRooms(data, isNew) {
      if (!isNew) {
        this.roomsLoaded = data.length === 0 || data.length < this.roomsPerPage
      }
      let roomId = 0;
      if (isNew && data.length === 1) {
        roomId = data[0].roomId;
        this.currentNewId = roomId.toString();
      }
      const roomsToAdd = [];
      for (let i = 0; i < data.length; i++) {
        const room = data[i];
        for (let j = 0; j < room.users.length; j++) {
          let cur = room.users[j]._id;
          let res = JSON.parse(sessionStorage.getItem(cur));
          if (res) {
            room.users[j].username = res.full_name;
          }
        }
        room.roomId = room.roomId.toString();
        const roomContacts = room.users.filter(
            user => user._id !== this.currentUserId
        )
        if (room.room_type === "chat") {
          room.roomName =
              roomContacts.map(user => user.username).join(', ')
          room.avatar = "/person_test.png"
        } else if (room.room_type === "group") {
          room.avatar = "/group_test.png"
        } else {
          room.avatar = "/assignment_test.png"
        }
        if (room.lastMessage) {
          room.lastMessage.timestamp = formatTimestamp(
              new Date(Date.parse(room.lastMessage.timestamp)),
              new Date(Date.parse(room.lastMessage.timestamp))
          )
        }
        if (isNew && room.uniqueness !== "") {
          // keep the new room at top until it is re-fetched or the user selects another room
          room.isNew = true;
          room.index = Number.MAX_SAFE_INTEGER;
        }
        let roomIndex = this.getRoomIndex(room.roomId);
        if (roomIndex !== -1) {
          this.rooms[roomIndex] = room;
          this.rooms = [...this.rooms]
        } else {
          roomsToAdd.push(room);
        }
      }

      this.rooms = this.rooms.concat(roomsToAdd)
      if (!this.rooms.length) {
        this.roomsLoadedCount = 0
      } else {
        this.roomsLoadedCount = this.rooms.length
      }
      this.loadingRooms = false
      if (roomId !== 0) {
        this.$nextTick(() => {
          this.roomId = roomId.toString();
        });
      }
    },
    getRoomIndex(roomId) {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === roomId) {
          return i;
        }
      }
      return -1;
    },
    resetMessages() {
      // check if we have an empty user chat at top
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].isNew === true && this.rooms[i].roomId !== this.currentNewId) {
          this.rooms.splice(i, 1);
          this.rooms = [...this.rooms]
          break
        }
      }
      this.currentNewId = '';
      this.messages = []
      this.messagesLoaded = false
      clearInterval(this.refreshMessagesTimer);
      this.refreshMessagesTimer = null;
    },
    fetchMessages({room, options = {}}) {
      if (options.reset) {
        this.resetMessages()
      }
      this.selectedRoom = room.roomId
      this.fetchMoreMessages(false);
    },
    fetchMoreMessages(refresh) {
      let req = {
        latest_message_id: "0",
        oldest_message_id: "0",
        is_refresh: "false",
        room_id: this.selectedRoom,
      }
      if (this.messages.length !== 0) {
        req.oldest_message_id = this.oldestMessage.toString();
        req.latest_message_id = this.latestMessage.toString();
      }
      if (refresh) {
        req.is_refresh = "true";
      }
      this.$http.get(
          Server_URL + '/auftragsbuch/messaging/room?' + new URLSearchParams(req).toString()
      ).then(response => {
        if (response.status === 200) {
          let data = response.body;
          for (let i = 0; i < data.length; i++) {
            if (data[i].value_3 === "system") {
              data[i].system = true;
            }
            if (data[i].message_type === 'file' && data[i].files) {
              for (let j = 0; j < data[i].files.length; j++) {
                data[i].files[j].server_url = Server_URL + "/auftragsbuch/" + data[i].files[j].url;
                data[i].files[j].url = this.getThumbnailUrl(Server_URL + "/auftragsbuch/" + data[i].files[j].url, data[i].files[j].id, data[i].files[j].type)
              }
            }
          }
          decryptChatMessages(sessionStorage.getItem("aes"), data).then(res => {
            if (refresh && res && res.length) {
              let hasNew = false;
              for (let i = 0; i < res.length; i++) {
                if (!res[i].system && res[i].senderId !== this.myUser) {
                  hasNew = true;
                }
              }
              if (hasNew) {
                var audioFile = new Audio('/notification.mp3');
                audioFile.play()
              }
            }
            this.processMessages(res, refresh ? "new" : "old")
            // set the new messages count of the rooms list to zero
            for (let i = 0; i < this.rooms.length; i++) {
              let cur = this.rooms[i];
              if (cur.roomId === this.selectedRoom && cur.unreadCount !== 0) {
                this.rooms[i].unreadCount = 0;
                this.rooms = [...this.rooms]
                break;
              }
            }
          })
        } else {
          this.hideLoader();
          window.location = Redirect_500;
        }
      }, this.responseError)
      if (!this.refreshMessagesTimer) {
        this.refreshMessagesTimer = setInterval(() => {
          this.fetchMoreMessages(true)
        }, messageRefreshRate)
      }
    },
    getMessageIndex(id) {
      let index = -1;
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i]._id === id) {
          return index;
        }
      }
      return -1;
    },
    processMessages(data, direction) {
      this.messagesLoaded = data.length === 0 || data.length < this.messagesPerPage;
      for (let i = 0; i < data.length; i++) {
        const message = this.formatMessage(data[i]);
        // check if the message already exists, if so update
        let index = this.getMessageIndex(message._id);
        if (index !== -1) {
          this.messages[index] = data[i];
        } else if (direction === 'new') {
          this.messages.push(data[i])
        } else {
          this.messages.unshift(data[i])
        }
      }
    },
    formatMessage(message) {
      message._id = message._id.toString();
      message.timestamp = parseTimestamp(new Date(Date.parse(message.timestamp)), 'HH:mm');
      message.date = parseTimestamp(new Date(Date.parse(message.date)), 'DD MMMM YYYY');
      //message.avatar = "https://cdn.pixabay.com/photo/2018/01/05/00/20/test-image-3061864_960_720.png";

      // set username
      let res = JSON.parse(sessionStorage.getItem(message.senderId));
      if (res !== null) {
        message.username = res.first_name + " " + res.surname;

        return message;
      }
    }
  }
}
</script>

<style>
form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.tree-default .tree-disabled > .tree-checkbox {
  display: none;
}

.tree-default .tree-disabled {
  color: inherit !important;
}

</style>

<style scoped>
#vac-circle {
  height: 20px;
  width: 20px;
}

#vac-circle {
  margin: auto;
  height: 28px;
  width: 28px;
  border: 3px rgba(0, 0, 0, .25) solid;
  border-top: 3px #333 solid;
  border-right: 3px #333 solid;
  border-bottom: 3px #333 solid;
  border-radius: 50%;
  -webkit-animation: vac-spin 1s infinite linear;
  animation: vac-spin 1s infinite linear;
}

@keyframes vac-spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0);
  }

  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}

.chat-avatar {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  font-size: 18px;
  color: rgb(255, 255, 255);
  text-align: center;
  background: rgb(0, 0, 0);
  margin-top: 5px;
  margin-left: 4px;
}

.chat-avatar.mine {
  background: rgb(203, 33, 33);
}

</style>

<style>
.vac-message-wrapper .vac-message-container {
  width: 90% !important;
}


.vac-message-wrapper .vac-message-box{
  width: 90% !important;
  min-width: 90% !important;
}

.vac-message-wrapper .vac-message-container {
  margin-left: 10% !important;
}
</style>
